import axios from 'axios';
import React, { useState } from 'react'
import { toast } from 'react-toastify';
import CloseIcon from '@mui/icons-material/Close';
import axiosInstanceSM from '../../../Utils/axiosSm';
import { useNavigate } from 'react-router-dom';
import { useMediaQuery } from '@mui/material';

function AddTeacher() {
    const isXs = useMediaQuery("(min-width:600px) and (max-width:3000px)");
    const [imagePreview, setImagePreview] = useState('');
    const [image, setImage] = useState('');
    const [teacherName, setTeacherName] = useState('');
    const [subject, setSubject] = useState('');
    const [course, setCourse] = useState();
    const [experience, setExperience] = useState();
    const [year, setYear] = useState('');
    const [description, setDescription] = useState('');
    const [text, setText] = useState("");
    const [chips, setChips] = useState([]);
    const [validationError, setValidationError] = useState("");
    const navigate = useNavigate();

    const handleFileChange = (e) => {


        const file = e.target.files[0];
        if (file) {
            const fileSizeInKB = file.size / 1024;
            if (fileSizeInKB > 100) {
                toast.error("File size must be less than 100 KB");
                return;
            }

            const img = new Image();
            img.onload = function () {
                if (img.width !== img.height) {
                    toast.error("Please upload a square image (equal width and height)");
                    setImage('');
                    setImagePreview('');
                } else {
                    setImage(file);
                    setImagePreview(URL.createObjectURL(file));
                }
            };
            img.onerror = function () {
                toast.error("Error loading image");
            };
            img.src = URL.createObjectURL(file);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault()
        const formdata = new FormData();
        formdata.append('facultyName', teacherName);
        formdata.append('facultyQualification', chips)
        formdata.append('facultySubject', subject)
        formdata.append('facultyClass', course)
        formdata.append('facultyExperiance', experience)
        formdata.append('facultyYear', year);
        formdata.append('facultyImage', image);
        formdata.append('facultyDescription', description)
        formdata.append('token', '123abc')

        try {
            const response = await axiosInstanceSM.post("/api/v1/expertFaculty ", formdata);
            if (response.data.success = true) {
                toast.success(response.data.message)
                navigate('/dashboard/expert-faculty/all-teacher');
                setTeacherName('')
                setChips('');
                setSubject('');
                setCourse('');
                setExperience('');
                setYear('');
                setImage('');
                setDescription('');
            }
        }
        catch (error) {
            if (error.response) {
                toast.error(error.response.data.message || 'Something went wrong!');
            }
        }
    }

    return (<>
        <form onSubmit={handleSubmit}>
            <div
                style={{ width: "100%", height: "4rem", backgroundColor: "#ffffff", borderRadius: "10px", marginTop: "0rem", display: "flex", alignItems: "center", padding: "1rem", justifyContent: "space-between", boxShadow: "0px 4px 4px 2px rgb(231, 231, 231)", }}
            >
                <span style={{ color: "#CB8B65", fontSize: "1.2rem", fontWeight: "600" }}>
                    Expert Faculty
                </span>
                <button type='submit' style={{ backgroundColor: '#CB8B65', padding: '10px 15px', color: 'white', borderRadius: '10px' }}>Publish</button>
            </div>

            <div style={{ padding: '1rem 1.5rem 0.5rem 1.5rem', fontSize: '20px' }}>Add Expert Faculty</div>
            <hr style={{ margin: '0px', border: '1px solid' }} />


            <div style={{ padding: '1rem 1.5rem', display: 'flex', flexDirection: "column", gap: '20px' }}>
                <div style={{ display: 'flex', gap: '20px', flexDirection:isXs ? "":'column' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                        <label style={{ fontSize: '16px', marginBottom: '6px', marginLeft: '10px', fontWeight: '500' }} htmlFor="title">Faculty Name</label>
                        <input onChange={(e) => setTeacherName(e.target.value)} required style={{ height: '40px', borderRadius: '10px', border: '1px solid', paddingLeft: '10px' }} type="text" placeholder="Enter Faculty Name" />
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>

                        <label style={{ fontSize: '16px', marginBottom: '6px', marginLeft: '10px', fontWeight: '500' }} htmlFor="title">Qualification</label>
                        <div >
                            <input
                                style={{ height: '40px', borderRadius: '10px', border: '1px solid', paddingLeft: '10px' }}
                                type="text"
                                placeholder="Enter Qualification"
                                onChange={(e) => setChips(e.target.value)}
                            />
                        </div>
                    </div>
                </div>
                <div style={{ display: 'flex', gap: '20px',flexDirection:isXs ? "":'column' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                        <label style={{ fontSize: '16px', marginBottom: '6px', marginLeft: '10px', fontWeight: '500' }} htmlFor="title">Expertise Subject</label>
                        <input onChange={(e) => setSubject(e.target.value)} required style={{ height: '40px', borderRadius: '10px', border: '1px solid', paddingLeft: '10px' }} type="text" placeholder=" Enter Expertise Subject" />
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                        <label style={{ fontSize: '16px', marginBottom: '6px', marginLeft: '10px', fontWeight: '500' }} htmlFor="title">Class & Course</label>
                        <input onChange={(e) => setCourse(e.target.value)} required style={{ height: '40px', borderRadius: '10px', border: '1px solid', paddingLeft: '10px' }} type="text" placeholder=" Enter Class & Course" />
                    </div>
                </div>

                <div style={{ display: 'flex', gap: '20px',flexDirection:isXs ? "":'column' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', width: isXs ? '22%':'100%'}}>
                        <label style={{ fontSize: '16px', marginBottom: '6px', marginLeft: '10px', fontWeight: '500' }} htmlFor="title">Experience</label>
                        <input onChange={(e) => { const value = e.target.value; if (/^\d{0,2}$/.test(value)) { setExperience(value); } }} value={experience} required style={{ height: '40px', borderRadius: '10px', border: '1px solid', paddingLeft: '10px' }} type="number" placeholder="Enter Experience" />
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'column', width: isXs ? '22%':'100%' }}>
                        <label style={{ fontSize: '16px', marginBottom: '6px', marginLeft: '10px', fontWeight: '500' }} htmlFor="category">Select Duration</label>
                        <select onChange={(e) => setYear(e.target.value)} required
                            id="category"
                            style={{ height: '40px', borderRadius: '10px', border: '1px solid', paddingLeft: '10px' }}>
                            <option value=''>None</option>
                            <option value="Months">Months</option>
                            <option value="Years">Years</option>
                        </select>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'center', width: isXs?  '50%':'100%', flexDirection: 'column' }}>
                        <label style={{ fontSize: '16px', marginBottom: '6px', marginLeft: '10px', fontWeight: '500' }} htmlFor="category">Upload Faculty Image</label>
                        <label htmlFor="file" style={{ cursor: 'pointer', height: isXs?  '40px':'90px', width: '100%', border: '1px solid #000', textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: '10px' }}>
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <div style={{ fontSize: '14px' }}>
                                    {imagePreview ? (
                                        <img style={{ border: '1px solid black' }} height={30} width={30} src={imagePreview} alt="Selected Preview" />
                                    ) : (
                                        <div style={{ display: 'flex', gap:isXs ?  '20px':"5px", alignItems:  'center', flexDirection:isXs ? '':'column' }}>
                                            <div style={{ border: '1px solid black', padding: isXs ? '4px 15px':'3px 10px', borderRadius: '7px', backgroundColor: 'gray', color: 'white' }}>
                                                Upload Image
                                            </div>

                                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                <div style={{ fontSize: '12px' }}>1:1 Aspect Ratio (Square Image)</div>
                                                <div style={{ fontSize: '12px' }}>Maximum file size 100KB</div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </label>
                        <input accept="image/*" required id="file" type="file" onChange={handleFileChange} style={{ display: 'none' }} />
                    </div>

                </div>

                <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                    <label style={{ fontSize: '16px', marginBottom: '6px', marginLeft: '10px', fontWeight: '500' }} htmlFor="title">Description</label>
                    <textarea onChange={(e) => setDescription(e.target.value)} required style={{ borderRadius: '10px', border: '1px solid', paddingLeft: '10px', paddingTop: '10px', height: '120px' }} type="text" placeholder="Description" />
                </div>
            </div>
        </form>
    </>)
}

export default AddTeacher